<div class="container-plans">
  <div class="container-title">
    <div class="box-title">
      <h2 class="copec-bold-40">
        Descubre tu mejor opción y disfruta sin límites
      </h2>
      <p class="copec-rg-16 mt-2">
        Porque tu calidad de vida nos importa, te ayudamos a escoger un plan que
        te dé más beneficios para ti y tus seres queridos.
      </p>
      <a class="button-plans mt-4" (click)="scrollToSection()">Recomiéndame un plan</a>
    </div>
  </div>
  <div class="cards-plans">
    <app-cards-plans></app-cards-plans>
  </div>
  <div>
    <img class="container-landingPlans" src="/assets/img/landing-plans.svg" alt=""/>
  </div>
  <div id="idplanes"></div>
  <div class="espacio"></div>
  <div class="container-general-plans">
    <div class="container-title-plansTwo">
      <h2 class="copec-rg-30">Te recomendamos el mejor plan para ti</h2>
      <p class="copec-rg-16">
        Ingresa la cantidad de beneficiarios para recomendarte que plan se
        adapta mejor a tus necesidades.
      </p>
    </div>

    <div class="container-menu-planes">
      <div class="subtitle-pain">
        <span class="copec-rg-16">Tu sueldo bruto es</span>
          <div *ngIf="showSalaryEye" class="box-show-amount">
            <div class="copec-rg-16 eyeOpen">* * * * * * *</div>        
            <div class="imgEye" (click)="showSalary()"><img src="/assets/icono-plans/icono-eye.svg" class="imgEye" alt=""/></div>
          </div>
          <div *ngIf="!showSalaryEye" class="box-show-amount">
            <div class="copec-rg-16 eyeOpen">${{salaryUserSap()}}</div>
            <div class="imgEye" (click)="showSalary()"><img src="/assets/icono-plans/eye-off.svg" class="iconEye" alt=""/></div>
          </div>
      </div>

      <div id="dropdownBenefit" class="dropdown" [ngClass]="{ show: dropdownOpen }" >
        <div>
          <span class="copec-rg-16">Beneficiarios adicionales</span>
          <div class="dropdown-toggle copec-rg-16" (click)="toggleDropdown()">
            {{ countAdultos + countHijos + countOtros }} Beneficiario
          </div>
        </div>
        <div class="option-menu">
          <div class="select-options">
            <section>
              <div class="option-description">
                <span class="copec-rg-16">Adultos</span>
                <span class="sub-title-option copec-lg-14"
                  >Padre, madre, cónyuge, conviviente civil o pareja</span
                >
              </div>
            </section>
            <div class="select-incremet-decrement">
              <button
                class="button-increment-decrement"
                (click)="decrement('adultos')"
              >
                -
              </button>
              <div>
                <span>{{ countAdultos }}</span>
              </div>
              <button
                class="button-increment-decrement"
                (click)="increment('adultos')"
              >
                +
              </button>
            </div>
          </div>

          <div class="select-options">
            <section>
              <div class="option-description">
                <span class="copec-rg-16">Hijos</span>
                <span class="sub-title-option copec-lg-14"
                  >Hijos estudiantes hasta 25 años</span
                >
              </div>
            </section>
            <div class="select-incremet-decrement">
              <button
                class="button-increment-decrement"
                (click)="decrement('hijos')"
              >
                -
              </button>
              <div>
                <span>{{ countHijos }}</span>
              </div>
              <button
                class="button-increment-decrement"
                (click)="increment('hijos')"
              >
                +
              </button>
            </div>
          </div>

          <div class="select-options">
            <section>
              <div class="option-description">
                <span class="copec-rg-16">Otros</span>
                <span class="sub-title-option copec-lg-14"
                  >Menores de edad bajo su tutela</span
                >
              </div>
            </section>
            <div class="select-incremet-decrement">
              <button
                class="button-increment-decrement"
                (click)="decrement('otros')"
              >
                -
              </button>
              <div>
                <span>{{ countOtros }}</span>
              </div>
              <button
                class="button-increment-decrement"
                (click)="increment('otros')"
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button class="button-recomend" (click)="recommendPlan()">Recomendar Plan</button>
      </div>
    </div>
  </div>
  <div class="table-plan">
    <app-table-plan [recommendedPlan]="recommendedPlan"></app-table-plan>
  </div>
  <div class="panel-plan">
    <app-panel-plan></app-panel-plan>
  </div>
</div>
